import { render } from "./DiyCampaignPage.vue?vue&type=template&id=6fd331e4"
import script from "./DiyCampaignPage.vue?vue&type=script&lang=js"
export * from "./DiyCampaignPage.vue?vue&type=script&lang=js"

import "./DiyCampaignPage.vue?vue&type=style&index=0&id=6fd331e4&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__